<form *ngIf="addEditForm && validation" [formGroup]="addEditForm" [ngClass]="{'invalid-submit': invalidSubmit}" (ngSubmit)="saveOrUpdate()" RestrictFocus >

  <div class="ui-grid ui-grid-responsive ui-fluid Loyalty">
    <!-- Division Sales Network -->
    <div class="ui-grid-row bottom-10-margin">
      <div class="ui-grid-col-4">
        <label>{{ 'salesNetworkList.saleNetwork' | translate }}</label>
      </div>
      <div class="ui-grid-col-8">
        <p-dropdown
        name="divisionSalesNetwork"
        [style]="{'width':'100%'}"
        formControlName="divisionSalesNetworkId"
        [(ngModel)]="divisionSalesNetwork"
        [options] ="dsnItems"
        [filter]="true"
        field="label">
        </p-dropdown>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="addEditForm" [validation]="validation.divisionSalesNetworkId"></app-validation-msg>
        <span class="input-error-notification" *ngIf="invalidSubmit && (!cluster && !service && !divisionSalesNetwork) ">{{ 'dsnOperationMailList.insertAtLeastOne' | translate }}</span>      
      </div>
    </div>

    <!-- Operation -->
    <div class="ui-grid-row bottom-10-margin">
      <div class="ui-grid-col-4">
        <label> {{ 'permissionForm.operationName' | translate }} </label>
      </div>
      <div class="ui-grid-col-8">
        <p-dropdown
        name="operationPid"
        [style]="{'width':'100%'}"
        formControlName="operationPid"
        [(ngModel)]="operationPid"
        [options] ="operationPidItems"
        (onChange)="setOperation()"
        [filter]="true"
        field="label">
        </p-dropdown>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="addEditForm" [validation]="validation.operationPid"></app-validation-msg>
      </div>
    </div>

    <!-- Email -->
    <div class="ui-grid-row bottom-10-margin">
      <div class="ui-grid-col-4"><label>{{ 'userForm.email' | translate }}</label></div>
      <div class="ui-grid-col-8">
        <input name="email" formControlName="email" type="email" pInputText required/>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="addEditForm" [arrayValidators]="[validators.emailOrEmpty]" [validation]="validation.email"></app-validation-msg>
      </div>
    </div>

    <!-- Cluster -->
    <div class="ui-grid-row bottom-10-margin">
      <div class="ui-grid-col-4">
        <label>{{ 'loyalty.cluster' | translate }}</label>
      </div>
      <div class="ui-grid-col-8">
        <p-dropdown
        name="cluster"
        [style]="{'width':'100%'}"
        formControlName="clusterId"
        [(ngModel)]="cluster"
        [options] ="clusterItems"
        [filter]="true"
        [disabled]="!flagCluster"
        field="label">
        </p-dropdown>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="addEditForm" [validation]="validation.clusterId"></app-validation-msg>
        <span class="input-error-notification" *ngIf="invalidSubmit && (flagCluster && !cluster)">{{ 'dsnOperationMailList.insertAtLeastOne' | translate }}</span>
      </div>
    </div>

    <!-- Service -->    
    <div class="ui-grid-row bottom-10-margin">
      <div class="ui-grid-col-4">
        <label> {{ 'dsnOperationMailList.serviceName' | translate }} </label>
      </div>
      <div class="ui-grid-col-8">
        <p-dropdown
        name="service"
        [style]="{'width':'100%'}"
        formControlName="serviceId"
        [(ngModel)]="service"
        [options] ="serviceItems"
        [filter]="true"
        [disabled]="!flagService"
        field="label">
        </p-dropdown>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="addEditForm" [validation]="validation.serviceId"></app-validation-msg>
        <span class="input-error-notification" *ngIf="invalidSubmit && (flagService && !service)">{{ 'dsnOperationMailList.insertAtLeastOne' | translate }}</span>
      </div>
    </div>

  </div>
  <p-footer>
    <div class="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix" style="display: flex; justify-content: center; border: 0;">
      <button class="k-generic-btn" type="submit" pButton icon="fa fa-check" label="{{ 'common.save' | translate }}"></button>
    </div>
  </p-footer>
</form>



// WEBPACK FOOTER //
// ./src/app/views/administration/dsn-operation-mail/dsn-operation-mail-form/dsn-operation-mail-form.component.html